import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { get } from 'lodash'
import { apiConfiguration } from 'helpers/decorators/api'
import { FormData } from 'components/misc'

@apiConfiguration()
class ConfigurationText extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    intlKey: PropTypes.string,
    configKey: PropTypes.string.isRequired,
    onGetConfigurationValue: PropTypes.func,
    organizationId: PropTypes.number,
    isPublic: PropTypes.bool,
    noFetch: PropTypes.bool,
    configuration: PropTypes.object
  }

  static defaultProps = {
    noFetch: false
  }

  state = {
    text: ''
  }

  componentDidMount() {
    // With noFetch the value is provided by a parent batch load and read from
    // the store in render(), so skip the per-text request.
    if (!this.props.noFetch) {
      this.handleRequestDownload()
    }
  }

  handleRequestDownload = () => {
    // eslint-disable-next-line
    let { organizationId, configKey, isPublic } = this.props

    if (isPublic) {
      organizationId = organizationId || 1
    }

    this.props
      .onGetConfigurationValue(configKey, organizationId, isPublic)
      .then(({ body } = {}) => {
        this.setState({
          text: get(body, 'translatedText')
        })
      })
  }

  render() {
    const { label, intlKey, noFetch, configuration, configKey } = this.props

    const text = noFetch
      ? get(configuration, `values[${configKey}].translatedText`)
      : this.state.text

    return (
      <FormData label={label} intlKey={intlKey}>
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </FormData>
    )
  }
}

export default ConfigurationText
